// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetDailyStatusTarotDailyStatusGetQueryResponse } from "../models/tarotController/GetDailyStatusTarotDailyStatusGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type {
  QueryKey,
  QueryClient,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";
import { getDailyStatusTarotDailyStatusGet } from "../client/getDailyStatusTarotDailyStatusGet.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const getDailyStatusTarotDailyStatusGetQueryKey = () =>
  [{ url: "/tarot/daily_status" }] as const;

export type GetDailyStatusTarotDailyStatusGetQueryKey = ReturnType<
  typeof getDailyStatusTarotDailyStatusGetQueryKey
>;

export function getDailyStatusTarotDailyStatusGetQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getDailyStatusTarotDailyStatusGetQueryKey();
  return queryOptions<
    GetDailyStatusTarotDailyStatusGetQueryResponse,
    ResponseErrorConfig<Error>,
    GetDailyStatusTarotDailyStatusGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getDailyStatusTarotDailyStatusGet({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Get Daily Status
 * {@link /tarot/daily_status}
 */
export function useGetDailyStatusTarotDailyStatusGet<
  TData = GetDailyStatusTarotDailyStatusGetQueryResponse,
  TQueryData = GetDailyStatusTarotDailyStatusGetQueryResponse,
  TQueryKey extends QueryKey = GetDailyStatusTarotDailyStatusGetQueryKey,
>(
  options: {
    query?: Partial<
      UseQueryOptions<
        GetDailyStatusTarotDailyStatusGetQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    (resolvedOptions && "queryKey" in resolvedOptions
      ? toValue(resolvedOptions.queryKey)
      : undefined) ?? getDailyStatusTarotDailyStatusGetQueryKey();

  const query = useQuery(
    {
      ...getDailyStatusTarotDailyStatusGetQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as UseQueryOptions<
      GetDailyStatusTarotDailyStatusGetQueryResponse,
      ResponseErrorConfig<Error>,
      TData,
      GetDailyStatusTarotDailyStatusGetQueryResponse,
      TQueryKey
    >,
    toValue(queryClient),
  ) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
